import { Center, Loader } from '@mantine/core';

/**
 * React.lazy ページの読み込み中に表示するフォールバック UI
 */
export function PageLoadingFallback() {
  return (
    <Center style={{ height: '100vh' }}>
      <Loader size="lg" />
    </Center>
  );
}
